import React, { useEffect } from 'react';
import { Grid, Button, Tooltip } from '@material-ui/core';
import spartacusIcon from '../../assets/images/spartacus_icon.svg';
import spartacusWordmark from '../../assets/images/spartacus_wordmark.svg';
import aiChatAssistantIcon from '../../assets/images/ai_chat_assistant_icon.svg';
import config from '../../../config';
import { getLocalStorageInfo } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
const upcomingAgents = [
    {
        initials: 'RS',
        title: 'Records Segregator',
        description: 'Automatically identify, classify and organise aircraft records.'
    },
    {
        initials: 'AV',
        title: 'AD/SB Applicability Validator',
        description: 'Assess Airworthiness Directive and Service Bulletin applicability.'
    },
    {
        initials: 'MR',
        title: 'MR Claims Agent',
        description: 'Support maintenance reserve claim preparation and validation.'
    },
    {
        initials: 'EG',
        title: 'Engine Redelivery Gap Reviewer',
        description: 'Review engine redelivery work packs, compare documentation against checklist requirements, and identify key gaps before redelivery.'
    }
]
export default function SpartacusHub() {
    const hasLeaseRevampAccess = getLocalStorageInfo()?.is_lease_revamp;
    useEffect(() => {
        trackActivity('Console Management', { page_title: 'Spartacus Hub', event_type: 'Page Visit', event_desc: 'Spartacus Hub Page Visited' })
    }, []);
    return (
        <section className="spartacus-hub-container">
            <div className="spartacus-banner">
                <img src={spartacusIcon} alt="SPARTACUS" className="spartacus-banner-icon" />
                <div className="spartacus-banner-content">
                    <img src={spartacusWordmark} alt="SPARTACUS AI Agents Hub" className="spartacus-banner-wordmark" />
                    <p>Your central workspace for intelligent aviation agents.</p>
                </div>
            </div>
            <Grid container spacing={3} className="agent-cards-wrapper">
                <Grid item xs={12} sm={6} md={3}>
                    <div className="agent-card active-agent">
                        <span className="agent-tag beta-tag">BETA</span>
                        <div className="agent-card-icon">
                            <img src={aiChatAssistantIcon} alt="Lease Management Chat Assistant" width="64" height="64" />
                        </div>
                        <h4>AI Chat Assistant</h4>
                        <span className="scope-tag">LEASE MANAGEMENT ONLY</span>
                        <p>Ask questions and get instant assistance for lease management workflows.</p>
                        <div className="assistant-action">
                            <Tooltip title={hasLeaseRevampAccess ? '' : 'Available only for those who have Lease Management access.'} arrow>
                                <span>
                                    <Button
                                        variant="contained"
                                        className="btn-open-assistant"
                                        disabled={!hasLeaseRevampAccess}
                                        onClick={() => {
                                            trackActivity('Console Management', { page_title: 'Spartacus Hub', item_type: 'AI Chat Assistant', event_type: 'Item Clicked', event_desc: 'Opened AI Chat Assistant from Spartacus Hub' })
                                            window.open(`${config.domain.leaseRevamp}ai-chat`, '_blank')
                                        }}
                                    >
                                        Open Assistant &rsaquo;
                                    </Button>
                                </span>
                            </Tooltip>
                            {!hasLeaseRevampAccess &&
                                <p className="access-note">Please contact <a href="mailto:support@sparta.aero">support@sparta.aero</a> to access.</p>
                            }
                        </div>
                    </div>
                </Grid>
                {upcomingAgents.map((agent, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <div className="agent-card upcoming-agent">
                            <span className="agent-tag upcoming-tag">UPCOMING</span>
                            <div className="agent-card-icon initials-icon">{agent.initials}</div>
                            <h4>{agent.title}</h4>
                            <p>{agent.description}</p>
                            <Button variant="contained" className="btn-coming-soon" disabled>Coming Soon</Button>
                        </div>
                    </Grid>
                ))}
            </Grid>
        </section>
    )
}
